import { useMemo } from 'react'
import {
  GetLiveMonitorCallStatesSubscription,
  GetLiveMonitorCallStatesSubscriptionVariables,
} from '../../../generated/graphql'
import GetLiveMonitorCallStates from '../graphql/subscriptions/GetLiveMonitorCallStates'
import useManualSubscription from './useManualSubscription'

export type UseLiveCallMonitorCallStatesConfig = {
  readingIds: string[]
  skip?: boolean
}

// readingIds changes over time (readings start/end), so the id list is joined into a
// stable key and re-opens the subscription whenever the set of monitored readings changes.
export default function useLiveCallMonitorCallStates({
  readingIds,
  skip = false,
}: UseLiveCallMonitorCallStatesConfig) {
  const readingIdsKey = readingIds.slice().sort().join(',')
  const isSkipped = skip || readingIds.length === 0

  const { data, loading, error } = useManualSubscription<
    GetLiveMonitorCallStatesSubscription,
    GetLiveMonitorCallStatesSubscriptionVariables
  >({
    query: GetLiveMonitorCallStates,
    variables: { readingIds },
    skip: isSkipped,
    restartKey: readingIdsKey,
  })

  const callStatesByReadingId = useMemo(() => {
    const grouped: Record<
      string,
      GetLiveMonitorCallStatesSubscription['live_call_state']
    > = {}

    data?.live_call_state.forEach((state) => {
      const list = grouped[state.reading_id] || []
      list.push(state)
      grouped[state.reading_id] = list
    })

    return grouped
  }, [data?.live_call_state])

  return { callStatesByReadingId, loading, error }
}
